import React from 'react'
import { useNavigate } from 'react-router'
import { APP_ROUTES } from '@/common/constants'
import BlogClickedAnalytics from '@/common/analytics/events/BlogClickedAnalytics'
import Blog from './types'

export const BlogCardLoadingState: React.FC = () => (
    <div className="self-stretch rounded-lg outline outline-1 outline-offset-[-1px] outline-border-outline inline-flex flex-col justify-start items-start overflow-hidden animate-pulse h-auto">
        <div className="self-stretch h-40 w-full bg-stone-100" />
        <div className="self-stretch p-4 flex flex-col justify-between items-start gap-4 flex-1 min-h-0">
            <div className="self-stretch flex flex-col justify-start items-start gap-2">
                <div className="h-4 w-3/4 bg-stone-100 rounded" />
                <div className="h-12 w-full bg-stone-100 rounded mt-2" />
            </div>
            <div className="self-stretch inline-flex justify-between items-center flex-wrap content-center">
                <div className="h-3 w-24 bg-stone-100 rounded" />
                <div className="h-3 w-20 bg-stone-100 rounded" />
            </div>
        </div>
    </div>
)

export const BlogCard: React.FC<{ blog?: Blog }> = ({ blog }) => {
    const navigate = useNavigate()

    if (!blog) return <BlogCardLoadingState />

    const open = () => {
        BlogClickedAnalytics.track({
            slug: blog.slug,
        })
        navigate(`${APP_ROUTES.BLOGS}/${blog.slug}`)
    }

    return (
        <div
            role="button"
            tabIndex={0}
            onClick={open}
            onKeyDown={(event) => {
                if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault()
                    open()
                }
            }}
            className="w-full self-stretch rounded-lg outline outline-1 outline-offset-[-1px] outline-border-outline inline-flex flex-col justify-start items-start overflow-hidden cursor-pointer h-auto"
        >
            <img
                className="self-stretch h-40 w-full object-cover"
                src={blog.thumbnailImage?.url}
                alt={blog.thumbnailImage?.alt ?? blog.title}
            />
            <div className="self-stretch p-4 rounded-lg flex flex-col justify-between items-start gap-4 flex-1 min-h-0">
                <div className="self-stretch flex flex-col justify-start items-start gap-2">
                    <div className="self-stretch justify-start text-black text-sm font-medium font-['Inter'] leading-5 line-clamp-1">
                        {blog.title}
                    </div>
                    <div className="self-stretch h-14 justify-start text-content-tertiary text-xs font-normal font-['Inter'] leading-5 overflow-hidden line-clamp-3">
                        {blog.summary}
                    </div>
                </div>
                <div className="self-stretch inline-flex justify-between items-center flex-wrap content-center">
                    <div className="justify-start text-content-tertiary text-xs font-normal font-['Inter'] leading-5">
                        {blog.publishedDate
                            ? new Date(blog.publishedDate).toLocaleDateString(undefined, {
                                  year: 'numeric',
                                  month: 'short',
                                  day: 'numeric',
                              })
                            : ''}
                    </div>
                    <div className="justify-start text-content-tertiary text-xs font-normal font-['Inter'] leading-5">
                        {blog.category}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BlogCard
